(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nayle-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-n-gallery]').forEach(function (gallery) {
    var slides = gallery.querySelectorAll('[data-n-slide]');
    var thumbs = gallery.querySelectorAll('[data-n-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-n-thumb');
        slides.forEach(function (slide) { slide.hidden = slide.getAttribute('data-n-slide') !== index; });
        thumbs.forEach(function (t) { t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false'); });
      });
    });
  });
  document.querySelectorAll('[data-n-order-form]').forEach(function (form) {
    var qty = form.querySelector('input[name="quantity"]');
    var totalEl = form.querySelector('[data-n-total]');
    var price = parseInt(form.dataset.price, 10) || 0;
    var fee = parseInt(form.dataset.fee, 10) || 0;
    var field = function (name) { return form.querySelector('[data-n-field="' + name + '"]'); };
    var getQty = function () { return Math.min(10, Math.max(1, parseInt(qty.value, 10) || 1)); };
    var render = function () {
      if (totalEl) totalEl.textContent = ((price * getQty() + fee) / 100).toString().replace(/\.0+$/, '') + ' DH';
    };
    form.querySelectorAll('[data-n-qty]').forEach(function (button) {
      button.addEventListener('click', function () {
        qty.value = Math.min(10, Math.max(1, getQty() + parseInt(button.dataset.nQty, 10)));
        render();
      });
    });
    qty.addEventListener('change', render);
    var normalizePhone = function (value) {
      var digits = value.replace(/[\s.\-()]/g, '');
      if (/^0[5-7]\d{8}$/.test(digits)) return '+212' + digits.slice(1);
      if (/^00212[5-7]\d{8}$/.test(digits)) return '+' + digits.slice(2);
      if (/^\+212[5-7]\d{8}$/.test(digits)) return digits;
      return null;
    };
    var setError = function (input, bad) {
      var error = document.getElementById(input.getAttribute('aria-describedby'));
      input.setAttribute('aria-invalid', bad ? 'true' : 'false');
      if (error) error.hidden = !bad;
      return bad;
    };
    form.querySelectorAll('[data-n-field]').forEach(function (input) {
      input.addEventListener('input', function () {
        if (input.getAttribute('aria-invalid') === 'true') setError(input, false);
      });
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var name = field('name').value.trim().replace(/\s+/g, ' ');
      var phone = normalizePhone(field('phone').value);
      var address = field('address').value.trim().replace(/\s+/g, ' ');
      var city = field('city').value.trim();
      var bad = [
        setError(field('name'), name.length < 2) && field('name'),
        setError(field('phone'), !phone) && field('phone'),
        setError(field('address'), address.length < 5) && field('address'),
        setError(field('city'), city.length < 2) && field('city')
      ].filter(Boolean);
      if (bad.length) { bad[0].focus(); return; }
      var parts = name.split(' ');
      var first = parts.length > 1 ? parts.shift() : '';
      var params = new URLSearchParams();
      params.set('checkout[shipping_address][first_name]', first);
      params.set('checkout[shipping_address][last_name]', parts.join(' '));
      params.set('checkout[shipping_address][address1]', address);
      params.set('checkout[shipping_address][city]', city);
      params.set('checkout[shipping_address][phone]', phone);
      params.set('checkout[shipping_address][country]', form.dataset.country || 'MA');
      var submit = form.querySelector('[type="submit"]');
      if (submit) { submit.disabled = true; submit.setAttribute('aria-busy', 'true'); }
      window.location.href = '/cart/' + form.dataset.variant + ':' + getQty() + '?' + params.toString();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
